export declare namespace InspectionStepPageTitleTokenSections {
	interface Title {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}
}

export type InspectionStepPageTitleTokens = {
	title: InspectionStepPageTitleTokenSections.Title;
	paddingTop: string;
	marginBottom: string;
};

export const title: InspectionStepPageTitleTokenSections.Title = {
	color: '{text.color}',
	fontSize: '32px',
	fontWeight: '500',
	lineHeight: '48px',
};

/**
 * Step page title (e.g. "Pavedimo vykdymo pasirašymas") — matches Figma Display/Display 70.
 * Semantic token for color; size/weight/line-height per design.
 */
export default {
	title,
	paddingTop: '0',
	marginBottom: '24px',
} satisfies InspectionStepPageTitleTokens;
